module.exports = __webpack_public_path__ + "media/images/emblems/Bettenhausen-coat_of_arms-840e793ad3d70f41c5a93a5b95a3f8cf.svg";